import Decimal from "decimal.js";
import { InputNumber } from "@goodfill/ui-components";
import { numberFormat } from "../number/numberFormat";

export type DecimalRange = [Decimal | null, Decimal | null];

export type DecimalRangeFilterProps = {
  value: DecimalRange;
  onChange: (value: DecimalRange) => void;
  leftIcon?: string;
  small?: boolean;
};

export function DecimalRangeFilter({ value, onChange, leftIcon, small }: DecimalRangeFilterProps) {
  return (
    <div className="flex flex-row">
      <InputNumber
        small={small}
        border="neutral"
        value={value[0]?.toNumber()}
        setValue={(left) => onChange([left !== null ? new Decimal(left) : null, value[1]])}
        placeholder={"Min"}
        formatValue={numberFormat}
        leftIcon={leftIcon}
      />
      <InputNumber
        small={small}
        border="neutral"
        value={value[1]?.toNumber()}
        setValue={(right) => onChange([value[0], right !== null ? new Decimal(right) : null])}
        placeholder={"Max"}
        formatValue={numberFormat}
        leftIcon={leftIcon}
      />
    </div>
  );
}
